import React, { useEffect, useState } from 'react';
import { Typography, Grid, Button } from '@material-ui/core';
import * as QueryString from 'query-string';
import { apiPost } from '../api/client';
import { useHistory } from 'react-router-dom';

export default function ConfirmEmail(props) {
  const history = useHistory();
  const queries = QueryString.parse(props.location.search);
  const token = queries.token;
  const [status, setStatus] = useState('loading');
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (!token) {
      setStatus('error');
      setMessage('Missing verification token.');
      return;
    }
    apiPost('/auth/email/confirm', { token }, { auth: false })
      .then(() => {
        setStatus('ok');
        setMessage('Your email has been verified. You can sign in now.');
      })
      .catch((err) => {
        setStatus('error');
        setMessage(err.message || 'Verification failed.');
      });
  }, [token]);

  return (
    <Grid
      container
      direction="column"
      justify="center"
      alignItems="center"
      style={{ width: '100vw', height: '80vh' }}
    >
      <Typography variant="h5" align="center" style={{ maxWidth: 480 }}>
        {status === 'loading' ? 'Verifying your email…' : message}
      </Typography>
      {status !== 'loading' && (
        <Button
          variant="contained"
          style={{ background: '#f5802c', color: 'white', marginTop: 30 }}
          onClick={() => history.push('/login')}
        >
          Go to login
        </Button>
      )}
    </Grid>
  );
}
